module.exports = __webpack_public_path__ + "media/images/humidity-yellow-1511efd31e663cccee7b2fa0f22dc931.svg";